import { Box, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Iconify from '../Iconify';

const CompanyListViewData = ({ company, columnWidth, handleCompanyClick }) => {

  if (!company) {
    return (
      <Box className='table_row'>
        <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.address }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#EA5E00', width: '50px' }}><Iconify icon='ri:arrow-right-s-line' /></Box>
      </Box>
    );
  }

  return (
    <Box className='table_row' onClick={() => handleCompanyClick(company.id)}>
      <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, maxWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
        <Typography className='tableBodyTypography'>{company?.name}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.address, maxWidth: columnWidth.address }}>
        <Typography className='tableBodyTypography'>{company?.street_address || 'N/A'}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: '50px' }}><Iconify icon='ri:arrow-right-s-line' /></Box>
    </Box>
  );
};

export default CompanyListViewData;